import { paymentAPI } from '../services/api';

const STORAGE_KEY = 'invincible_pending_razorpay_verify_v1';
const MAX_AGE_MS = 48 * 60 * 60 * 1000;

function readPending() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function savePendingRazorpayCheckout({ bookingId, paymentFor, orderId }) {
  if (!bookingId || !orderId) return;
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      bookingId: String(bookingId),
      paymentFor: paymentFor === 'remaining' ? 'remaining' : 'advance',
      orderId: String(orderId),
      savedAt: Date.now()
    })
  );
}

export function savePendingRazorpayResponse(response) {
  const pending = readPending();
  if (!pending) return;
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      ...pending,
      razorpay_order_id: response?.razorpay_order_id || response?.razorpayOrderId || '',
      razorpay_payment_id: response?.razorpay_payment_id || response?.razorpayPaymentId || '',
      razorpay_signature: response?.razorpay_signature || response?.razorpaySignature || '',
      capturedAt: Date.now()
    })
  );
}

export function clearPendingRazorpayVerify() {
  sessionStorage.removeItem(STORAGE_KEY);
}

/** Retry verify when UPI pay succeeded but the first verify call failed (network / 401). */
export async function retryPendingRazorpayVerification() {
  if (!localStorage.getItem('token')) return { retried: false };

  const pending = readPending();
  if (!pending?.bookingId || !pending?.razorpay_payment_id || !pending?.razorpay_signature) {
    return { retried: false };
  }

  const ageBase = Number(pending.capturedAt || pending.savedAt || 0);
  if (!ageBase || Date.now() - ageBase > MAX_AGE_MS) {
    clearPendingRazorpayVerify();
    return { retried: false };
  }

  try {
    await paymentAPI.verifyBookingPayment(pending.bookingId, {
      razorpay_order_id: pending.razorpay_order_id,
      razorpay_payment_id: pending.razorpay_payment_id,
      razorpay_signature: pending.razorpay_signature,
      paymentFor: pending.paymentFor || 'advance'
    });
    clearPendingRazorpayVerify();
    return { retried: true, success: true };
  } catch (err) {
    const msg = String(err?.response?.data?.message || err?.message || '');
    if (/already verified|already recorded/i.test(msg)) {
      clearPendingRazorpayVerify();
      return { retried: true, success: true };
    }
    return { retried: true, success: false, error: err };
  }
}
